/* eslint-disable react-hooks/exhaustive-deps */
import axios from '../../../../lib/axios';
import { useEffect, useState } from 'react';
import { SuppliesDivisionModel } from '../../../../models/suppliesDivisionModel';
import { SuppliesMainGroupName } from '../../../../models/suppliesMain';
import { SuppliesCategoryProduct } from '../../../../models/suppliesCategoryProduct';
import { SuppliesProductSubCategory } from '../../../../models/suppliesSubCategory';
import {
  MASTER_CATEGORIES_DELETE,
  MASTER_DIVISION_DELETE,
  MASTER_SUB_CATEGORIES_DELETE,
} from '../../../../lib/endpoints/category';
import { getMasterDivision } from '../../../../services/masterDivision';
import { getMasterCategory } from '../../../../services/masterCatgegory';
import { getMasterSubCategory } from '../../../../services/masterSubCategory';

interface Props {
  data: SuppliesMainGroupName[];
}

export const useFormMainCategoryController = ({ data }: Props) => {
  const [dataDivision, setDataDivision] = useState<SuppliesDivisionModel[]>([]);
  const [dataCategoryProduct, setDataCategoryProduct] = useState<SuppliesCategoryProduct[]>([]);
  const [dataSubCategory, setDataSubCategory] = useState<SuppliesProductSubCategory[]>([]);
  const [openCategoryProduct, setOpenCategoryProduct] = useState<boolean>(false);
  const [openSubCategory, setOpenSubCategory] = useState<boolean>(false);
  const [selectedIdDivision, setSelectedIdDivision] = useState<SuppliesDivisionModel>(null!);
  const [selectedIdCategoryProduct, setSelectedIdCategoryProduct] =
    useState<SuppliesCategoryProduct>(null!);
  const [openFormDivision, setOpenFormDivision] = useState<boolean>(false);
  const [openFormCategory, setOpenFormCategory] = useState<boolean>(false);
  const [openFormSubCategory, setOpenFormSubCategory] = useState<boolean>(false);
  const [openDeleteDivision, setOpenDeleteDivision] = useState<boolean>(false);
  const [openDeleteCategoryPro, setOpenDeleteCategoryPro] = useState<boolean>(false);
  const [openDeleteSubcategory, setOpenDeleteSubCategory] = useState<boolean>(false);
  const [selectedEditDivision, setSelectedEditDivision] = useState<SuppliesDivisionModel>(null!);
  const [selectedEditCategory, setSelectedEditCategory] = useState<SuppliesCategoryProduct>(null!);
  const [selectedEditSubCategory, setSelectedEditSubCategory] =
    useState<SuppliesProductSubCategory>(null!);
  const [selectedDivId, setSelectedDivId] = useState<string>(null!);
  const [selectedCatProId, setSelectedCatProId] = useState<string>(null!);
  const [selectedSubCatId, setSelectedSubCatId] = useState<string>(null!);
  const [loadingDeleteDivision, setLoadingDeleteDivision] = useState<boolean>(false);
  const [loadingDeleteCategoryPro, setLoadingDeleteCategoryPro] = useState<boolean>(false);
  const [loadingDeleteSubCategory, setLoadingDeleteSubCategory] = useState<boolean>(false);
  const [selectedItemIdOne, setSelectedItemIdOne] = useState<string>(null!);
  const [selectedItemIdTwo, setSelectedItemIdTwo] = useState<string>(null!);
  const [loadingDivision, setLoadingDivision] = useState<boolean>(false);
  const [loadingCategories, setLoadingCategories] = useState<boolean>(false);
  const [loadingSubCategory, setLoadingSubCategory] = useState<boolean>(false);

  //================================> fetch Data
  const handleFetchDivision = async (): Promise<void> => {
    try {
      setLoadingDivision(true);
      const getDiv = await getMasterDivision(getMainId);
      setDataDivision(getDiv);
    } catch (err) {
      // console.log('error', err);
    } finally {
      setLoadingDivision(false);
    }
  };

  const handleFetchCategoryProduct = async (): Promise<void> => {
    try {
      setLoadingCategories(true);
      const res = await getMasterCategory(selectedIdDivision.id);
      setDataCategoryProduct(res);
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingCategories(false);
    }
  };

  const handleFetchDataSubCategory = async (): Promise<void> => {
    try {
      setLoadingSubCategory(true);
      const res = await getMasterSubCategory(selectedIdCategoryProduct.id);
      setDataSubCategory(res);
    } catch (err) {
      // console.log(err);
    } finally {
      setLoadingSubCategory(false);
    }
  };

  //================================> delete Event

  const handleDeleteDivision = async () => {
    try {
      setLoadingDeleteDivision(true);
      await axios.delete(`${MASTER_DIVISION_DELETE + selectedDivId}`);
      await handleFetchDivision();
    } catch (error: any) {
      try {
        window.alert(error.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      handleCloseDeleteDivision();
      setLoadingDeleteDivision(false);
    }
  };

  const handleDeleteCategoryProduct = async () => {
    try {
      setLoadingDeleteCategoryPro(true);
      await axios.delete(`${MASTER_CATEGORIES_DELETE + selectedCatProId}`);
      await handleFetchCategoryProduct();
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      handleCloseDeleteCategoryProduct();
      setLoadingDeleteCategoryPro(false);
    }
  };

  const handleDeleteSubCategory = async () => {
    try {
      setLoadingDeleteSubCategory(true);
      await axios.delete(`${MASTER_SUB_CATEGORIES_DELETE + selectedSubCatId}`);
      await handleFetchDataSubCategory();
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      handleCloseDeleteSubCategory();
      setLoadingDeleteSubCategory(false);
    }
  };

  //================================> open Event

  const handleOpenCategoryProduct = async (id: string) => {
    await handleFetchCategoryProduct();
    const filterDataDivision = dataDivision.filter((item) => item.id === id)[0];
    setSelectedIdDivision(filterDataDivision);
    setSelectedItemIdOne(id);
    setOpenCategoryProduct(true);
    setOpenSubCategory(false);
  };

  const handleOpenSubCategory = async (id: string) => {
    setLoadingCategories(false);
    await handleFetchDataSubCategory();
    setOpenSubCategory(true);
    const filterDataCategory = dataCategoryProduct.filter((item) => item.id === id)[0];
    setSelectedIdCategoryProduct(filterDataCategory);
    setSelectedItemIdTwo(id);
  };

  const handleOpenFormDivision = () => {
    setOpenFormDivision(true);
  };

  const handleCloseFormDivision = () => {
    setOpenFormDivision(false);
  };

  const handleOpenEditDivision = (id: string) => {
    setOpenFormDivision(true);
    const getDivision = dataDivision.filter((item) => item.id === id)[0];
    setSelectedEditDivision(getDivision);
  };

  const handleOpenFormCategory = () => {
    setOpenFormCategory(true);
  };

  const handleCloseFormCategory = () => {
    setOpenFormCategory(false);
  };

  const handleEditCategoryForm = (id: string) => {
    setOpenFormCategory(true);
    const getCategory = dataCategoryProduct.filter((item) => item.id === id)[0];
    setSelectedEditCategory(getCategory);
  };

  const handleOpenFormSubCategory = () => {
    setOpenFormSubCategory(true);
  };

  const handleCloseFormSubCategory = () => {
    setOpenFormSubCategory(false);
  };

  const handleEditSubCategoryForm = (id: string) => {
    setOpenFormSubCategory(true);
    const getSubCategory = dataSubCategory.filter((item) => item.id === id)[0];
    setSelectedEditSubCategory(getSubCategory);
  };

  const handleOpenDeleteDivision = (id: string) => {
    setOpenDeleteDivision(true);
    setSelectedDivId(id);
  };

  const handleCloseDeleteDivision = () => {
    setOpenDeleteDivision(false);
  };

  const handleOpenDeleteCategoryProduct = (id: string) => {
    setOpenDeleteCategoryPro(true);
    setSelectedCatProId(id);
  };

  const handleCloseDeleteCategoryProduct = () => {
    setOpenDeleteCategoryPro(false);
  };

  const handleOpenDeleteSubCategory = (id: string) => {
    setOpenDeleteSubCategory(true);
    setSelectedSubCatId(id);
  };

  const handleCloseDeleteSubCategory = () => {
    setOpenDeleteSubCategory(false);
  };

  //===============================> filter
  const filterDataMain = data.filter((item) => item.id);
  const getMain = filterDataMain.length > 0 ? filterDataMain[0] : null;
  const getMainId = getMain ? getMain.id : null;

  //================================> useEffect
  useEffect(() => {
    handleFetchDivision();
  }, []);

  useEffect(() => {
    if (selectedIdDivision) {
      handleFetchCategoryProduct();
    }
  }, [selectedIdDivision]);

  useEffect(() => {
    if (selectedIdCategoryProduct) {
      handleFetchDataSubCategory();
    }
  }, [selectedIdCategoryProduct]);

  return {
    dataDivision,
    dataCategoryProduct,
    dataSubCategory,
    handleFetchDivision,
    handleFetchCategoryProduct,
    handleFetchDataSubCategory,
    loadingDeleteDivision,
    handleCloseDeleteDivision,
    handleOpenDeleteDivision,
    openDeleteDivision,
    handleDeleteDivision,
    openDeleteCategoryPro,
    openDeleteSubcategory,
    handleDeleteCategoryProduct,
    loadingDeleteCategoryPro,
    handleOpenDeleteCategoryProduct,
    handleCloseDeleteCategoryProduct,
    handleOpenDeleteSubCategory,
    handleCloseDeleteSubCategory,
    loadingDeleteSubCategory,
    handleDeleteSubCategory,
    handleCloseFormDivision,
    handleOpenFormDivision,
    openFormDivision,
    handleOpenEditDivision,
    selectedEditDivision,
    selectedDiv: (NewValue: SuppliesDivisionModel) => setSelectedEditDivision(NewValue),
    openFormCategory,
    handleOpenFormCategory,
    handleCloseFormCategory,
    handleEditCategoryForm,
    selectedEditCategory,
    selectedCat: (NewValue: SuppliesCategoryProduct) => setSelectedEditCategory(NewValue),
    openFormSubCategory,
    handleOpenFormSubCategory,
    handleCloseFormSubCategory,
    handleEditSubCategoryForm,
    selectedEditSubCategory,
    selectedSubCat: (NewValue: SuppliesProductSubCategory) => setSelectedEditSubCategory(NewValue),
    handleOpenCategoryProduct,
    openCategoryProduct,
    handleOpenSubCategory,
    openSubCategory,
    selectedIdDivision,
    selectedIdCategoryProduct,
    selectedItemIdOne,
    selectedItemIdTwo,
    loadingSubCategory,
    loadingDivision,
    loadingCategories,
    getMain,
  };
};
